import { render, staticRenderFns } from "./AttachLossPriceField.vue?vue&type=template&id=449906d0"
import script from "./AttachLossPriceField.vue?vue&type=script&lang=js"
export * from "./AttachLossPriceField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports